import { useContext } from 'react'
import { PassContext } from '../../pass-context.js'

import _ from 'lodash'

import Card from './components/card.jsx'
import Logo from './components/logo.jsx'
import AppLinkLogo from './components/app-link-logo.jsx'
import HeaderFields from './components/header-fields.jsx'
import Fields from './components/fields.jsx'
import Barcode from './components/barcode.jsx'
import StripImage from './components/strip-image.jsx'
import ThumbnailImage from './components/thumbnail-image.jsx'

const Event = ({ passFieldCount }) => {

  const { subType } = useContext(PassContext)

  if (subType === "BACKGROUND")
    return event_background({ passFieldCount })
  else
    return event_strip({ passFieldCount })
}

export default Event

const event_strip = ({ passFieldCount }) => {
  return (
    <div className="relative">
      <Card>
        <Logo />
        <HeaderFields maxFields={passFieldCount.header} />
        <StripImage maxFields={passFieldCount.primary} />
        <Fields maxFields={passFieldCount.secondary} fieldType="secondary" />
        <Fields maxFields={passFieldCount.auxiliary} fieldType="auxiliary" />
        <AppLinkLogo />
        <Barcode />
      </Card>
      <Clipmap />
    </div>
  )
}

const event_background = ({ passFieldCount }) => {

  const { template } = useContext(PassContext)
  const primaryFieldWidth = template.meta.images?.thumbnail ? 220 : 300
  const primaryFieldHeight = 50

  return (
    <div className="relative">
      <Card showBackgroundImage={true}>
        <Logo />
        <HeaderFields maxFields={passFieldCount.header} />
        <ThumbnailImage />
        <Fields maxFields={passFieldCount.primary} fieldType="primary" fieldsOverallWidth={primaryFieldWidth} fieldsOverallHeight={primaryFieldHeight} />
        <Fields maxFields={passFieldCount.secondary} fieldType="secondary" fieldsOverallWidth={primaryFieldWidth} />
        <Fields maxFields={passFieldCount.auxiliary} fieldType="auxiliary" />
        <AppLinkLogo />
        <Barcode />
      </Card>
      <Clipmap />
    </div>

  )
}

const Clipmap = () => (
  <svg className='apple-svg-clip absolute top-0'>
    <defs>
      <clipPath id="apple_clip_path">
        <path id="clip" d="M 1 0 L 155.542 0 C 163.064 9.318 174.58 15.277 187.487 15.277 C 200.394 15.277 211.91 9.318 219.432 0 L 374 0 C 374.552 0 375 0.448 375 1 L 375 522 C 375 522.552 374.552 523 374 523 L 1 523 C 0.448 523 0 522.552 0 522 L 0 1 C 0 0.448 0.448 0 1 0 Z"/>
      </clipPath>
    </defs>
    <use href="#clip" />
  </svg>
)